import { FC } from 'react';

import getVariablePlainText from '@/lib/get-variable-plain-text';
import useVariables from '@/lib/hooks/use-variables';

const ProfileError: FC = () => {
  const variables = useVariables();

  const title =
    getVariablePlainText(variables['account-profile-error-title']) ||
    'Profil konnte nicht geladen werden';
  const description =
    getVariablePlainText(variables['account-profile-error-text']) ||
    'Bitte versuche es erneut. Deine Anmeldung ist aktiv, die Profildaten sind momentan nicht verfügbar.';

  return (
    <div className="max-w-[560px] mx-auto bg-gray-1 border border-gray-2 rounded-4 p-6">
      <h2 className="text-h4 mb-3">{title}</h2>
      <p className="text-body2">{description}</p>
    </div>
  );
};

export default ProfileError;
